import { isFacebookEmbedCode, isFacebookUrl } from '@@utils/socialMedia/facebook';

export default (value) => {
    if (!isFacebookUrl(value) && !isFacebookEmbedCode(value)) {
        // t('validator.message.validUrlOrEmbedCode');
        return ['validator.message.validUrlOrEmbedCode'];
    }
};
